// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__24D6W","gfeWrapper":"CalendarEvent_gfeWrapper__1mWmh"};